import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { REGISTER } from "@/constants/testIds";
import { RegisterForm } from "@/components/auth/RegisterForm";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleFieldChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    const result = await register(form.name, form.email, form.password);
    setLoading(false);
    if (result.success) {
      navigate("/feed");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-bbap-bg">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo showText={false} size="h-20" />
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          <h1 className="font-display font-bold uppercase text-2xl text-zinc-950 text-center mb-2">Join BBAP</h1>
          <p className="text-zinc-500 text-sm text-center mb-6">Your voice. Your vote. Your power.</p>

          {error && (
            <div data-testid="register-error-message" className="mb-4 p-3 rounded-sm bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
          )}

          <RegisterForm
            name={form.name} email={form.email} password={form.password} confirmPassword={form.confirmPassword}
            loading={loading} onChange={handleFieldChange} onSubmit={handleSubmit}
          />

          <p className="text-center text-sm text-zinc-500 mt-6">
            Already have an account?{" "}
            <Link to="/login" data-testid={REGISTER.loginLink} className="text-[#1E3A6E] font-semibold hover:underline">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
